'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  ', ';\n'], ['\n  background-color: ', ';\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n'], ['\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Copyright = require('./components/Copyright');

var _Copyright2 = _interopRequireDefault(_Copyright);

var _Links = require('./components/Links');

var _Links2 = _interopRequireDefault(_Links);

var _Trust = require('./components/Trust');

var _Trust2 = _interopRequireDefault(_Trust);

var _buoyTheme = require('buoy-theme');

var _buoyConfig = require('buoy-config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'src__Container',
  componentId: 'dk8yj2-0'
})(_templateObject, function (props) {
  return _buoyTheme.colors[props.backgroundColor];
}, (0, _buoyTheme.responsive)("padding", "48px 20px 18px 20px", "48px 20px 18px 20px", "48px 20px 18px 20px", "48px 20px 18px 20px", "38px 16px 18px 16px"));

var InnerContainer = _styledComponents2.default.div.withConfig({
  displayName: 'src__InnerContainer',
  componentId: 'dk8yj2-1'
})(_templateObject2);

var LegalContainer = (0, _styledComponents2.default)(Container).withConfig({
  displayName: 'src__LegalContainer',
  componentId: 'dk8yj2-2'
})(_templateObject3, (0, _buoyTheme.responsive)("padding", "4px 16px 18px 16px", "4px 16px 18px 16px", "4px 16px 18px 16px", "4px 16px 18px 16px", "4px 16px 18px 16px"));

var FooterWrapper = function FooterWrapper(_ref) {
  var _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === undefined ? _buoyConfig.navConfig.brands.default.baseUrl : _ref$baseUrl;
  return _react2.default.createElement(
    'footer',
    null,
    _react2.default.createElement(
      Container,
      null,
      _react2.default.createElement(
        InnerContainer,
        null,
        _react2.default.createElement(_Links2.default, { content: _buoyConfig.footerConfig.groups, baseUrl: baseUrl }),
        _react2.default.createElement(_Trust2.default, null)
      )
    ),
    _react2.default.createElement(
      LegalContainer,
      { backgroundColor: 'neutralDarkest' },
      _react2.default.createElement(
        InnerContainer,
        null,
        _react2.default.createElement(_Copyright2.default, { links: _buoyConfig.footerConfig.legal, baseUrl: baseUrl })
      )
    )
  );
};

Container.defaultProps = {
  backgroundColor: "neutralDarker"
};

exports.default = FooterWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-footer/dist/index.js
// module id = 108
// module chunks = 168707334958949